import Constants from '~/utils/constants';

// ATENÇÃO — divergência conhecida (2026-09-15): esta lista é a fonte usada por
// privateRoute.tsx para BLOQUEAR acesso a rota, mas não é a mesma lista de
// src/components/sidebar/routesConfig.tsx (usada para exibir o menu). As duas
// já divergiram: ~79 rotas do menu não têm entrada aqui (logo, ficam SEM
// restrição de papel via privateRoute — acessíveis a qualquer autenticado) e
// 24 rotas presentes nos dois arquivos têm conjuntos de papéis diferentes.
// Antes de editar papéis de rota, decida com o time de produto/segurança qual
// lista deve prevalecer — não assuma que as duas estão sincronizadas.
export const routesConfig = [
  // Home/Dashboard
  {
    route: '/homeDash',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_OPERATOR,
      Constants.ROLE_ASSESSORIA,
      Constants.ROLE_RETAGUARDA,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },

  // Consulta Transação
  {
    route: '/consult/transaction',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_RETAGUARDA,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },
  {
    route: '/consult-transaction/digital-wallet',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_RETAGUARDA,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },

  // Consulta
  {
    route: '/consult/user',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_RETAGUARDA,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },

  {
    route: '/consult/dispute',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },

  // Fechamento Fatura
  {
    route: '/creditosDisponiveis',
    roles: [Constants.ROLE_ADMIN],
  },

  // Mesa de crédito
  {
    route: '/credit-table/proposal',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_OPERATOR,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },
  {
    route: '/credit-table/report',
    roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
  },
  {
    route: '/credit-table/limit/solicitation',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_RETAGUARDA,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },
  {
    route: '/credit-table/limit/decision',
    roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
  },
  {
    route: '/credit-table/reactivate/decision',
    roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
  },
  // Fatura
  {
    route: '/invoice',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_ASSESSORIA,
      Constants.ROLE_RETAGUARDA,
      Constants.ROLE_OPERATOR,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },
  {
    route: '/invoice/antecipation',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_RETAGUARDA,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },
  {
    route: '/invoice/antecipation/purchase',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_RETAGUARDA,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },
  {
    route: '/invoice/antecipation/conference',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_RETAGUARDA,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },
  {
    route: '/invoice/advance-financing/conference',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_RETAGUARDA,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },
  {
    route: '/invoice/antecipation/purchase/history',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_RETAGUARDA,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },
  {
    route: '/invoice/advance-financing/history',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_RETAGUARDA,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },
  {
    route: '/invoice/purchase-inclusion',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_MESA_CREDITO,
    ],
  },
  {
    route: '/invoice/purchase-decision',
    roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
  },
  {
    route: '/invoice/reprocess',
    roles: [Constants.ROLE_ADMIN],
  },

  // Vendas
  {
    route: '/sales',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_RETAGUARDA,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },
  {
    route: '/sales/eventCenter',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_RETAGUARDA,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },
  {
    route: '/sales/eventCenter/requestEvent',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_RETAGUARDA,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },
  {
    route: '/sales/eventCenter/leadSolicitation',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_RETAGUARDA,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },
  {
    route: '/sales/eventCenter/upgradeSolicitation',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_RETAGUARDA,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },
  // Usuário
  {
    route: '/consult/audit',
    roles: [Constants.ROLE_ADMIN],
  },
  {
    route: '/consult/employee',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },
  // Relatório
  {
    route: '/report',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },
  {
    route: '/report/wallet',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },
  {
    route: '/report/proposal',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },
  {
    route: '/report/financial',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },
  // Arquivos
  {
    route: '/file/upload',
    roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
  },
  {
    route: '/file/history',
    roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
  },
  {
    route: '/file/documents',
    roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
  },
  {
    route: '/file/documents/history',
    roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
  },
  {
    route: '/file/documents/detalhes',
    roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
  },
  {
    route: '/file/charge',
    roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
  },
  {
    route: '/file/positive',
    roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
  },
  {
    route: '/file/proposal',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },
  {
    route: '/file/activeLimits',
    roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
  },
  {
    route: '/file/customer-base',
    roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
  },
  {
    routes: '/file/invoice-file',
    roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
  },
  {
    routes: '/file/cancel-inactivity',
    roles: [Constants.ROLE_ADMIN, Constants.ROLE_SUPERVISOR],
  },
  // Recursos
  {
    route: '/campanha',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_RETAGUARDA,
      Constants.ROLE_OPERATOR,
      Constants.ROLE_ASSESSORIA,
    ],
  },
  {
    route: '/lista-cliente-campanha',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_RETAGUARDA,
      Constants.ROLE_OPERATOR,
      Constants.ROLE_ASSESSORIA,
    ],
  },
  {
    route: '/management-tools/products',
    roles: [Constants.ROLE_ADMIN],
  },
  {
    route: '/management-tools/personalize-app-home',
    roles: [Constants.ROLE_ADMIN],
  },
  {
    route: '/management-tools/authorized-ips',
    roles: [Constants.ROLE_ADMIN],
  },
  // parametros
  {
    route: '/parameters/all',
    roles: [Constants.ROLE_ADMIN],
  },
  {
    route: '/parameters/events-center',
    roles: [Constants.ROLE_ADMIN],
  },
  {
    route: '/negociacao-dividas/cliente',
    roles: [Constants.ROLE_MESA_CREDITO],
  },
  {
    route: '/negociacao-dividas/buscar-cliente',
    roles: [Constants.ROLE_MESA_CREDITO],
  },
  {
    route: '/negociacao-dividas/acordos-ativos',
    roles: [Constants.ROLE_MESA_CREDITO],
  },
  {
    route: '/negociacao-dividas/acordos-ativos/detalhes',
    roles: [Constants.ROLE_MESA_CREDITO],
  },
  {
    route: '/negociacao-dividas/historico',
    roles: [Constants.ROLE_MESA_CREDITO],
  },
  {
    route: '/negociacao-dividas/historico/detalhes',
    roles: [Constants.ROLE_MESA_CREDITO],
  },
  {
    route: '/dashboard/push',
    roles: [
      Constants.ROLE_ADMIN,
      Constants.ROLE_SUPERVISOR,
      Constants.ROLE_OPERATOR,
      Constants.ROLE_ASSESSORIA,
      Constants.ROLE_RETAGUARDA,
      Constants.ROLE_MESA_CREDITO,
      Constants.ROLE_LIDER_VENDAS,
    ],
  },
];
